:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 0 0 calc(var(--spacer) * 2);
}

gz-labeled-content[class*='devices-labeled-content'] {
  &::part(content) {
    margin-top: -4px;
  }
}

.group-buttons > * {
  padding-top: var(--spacer);
}
